import React from 'react'
import { useLocale } from '../../../../extensions/Locale/useLocale'
import constants from '../../../../Utils/constants'

const FilterSelection: Client.ReportMap.FilterSelection = ({ filters, filters_set }) => {
    const { lang } = useLocale<Locale.Keys>()
    return (
        <div className="filterSelection">
            <h2>{lang.pages.reportsMap.seenThing}</h2>
            <div className="seenThingSelection">
                {constants.seenThingOptions.map((seenThing) => (
                    <div
                        onClick={() => {
                            filters_set((oldFilters) => {
                                return {
                                    ...oldFilters,
                                    seenThing: {
                                        ...oldFilters.seenThing,
                                        [seenThing.name]:
                                            oldFilters && oldFilters.seenThing && (oldFilters.seenThing as any)[seenThing.name]
                                                ? false
                                                : true,
                                    },
                                }
                            })
                        }}
                        className={
                            'filterCheckBoxItem' +
                            (filters && filters.seenThing && (filters.seenThing as any)[seenThing.name] ? ' selected' : '')
                        }
                    >
                        <p>{lang[seenThing.name].title}</p>
                        <div className="colorLegend" style={{ backgroundColor: seenThing.color }}></div>
                    </div>
                ))}
            </div>
            <h2>{lang.pages.reportsMap.limitReportsByDate}</h2>
            <div className="dateSelectionRow">
                <label htmlFor="minDateInput">{lang.pages.reportsMap.from}</label>
                <div>
                    <input
                        type="date"
                        className="DYSTInput"
                        id="minDateInput"
                        value={filters.minDate ? formatDate(filters.minDate) : ''}
                        onChange={(e) => {
                            const saveEvent = e.target
                            filters_set((oldFilters) => {
                                return {
                                    ...oldFilters,
                                    minDate: saveEvent.valueAsDate || null,
                                }
                            })
                        }}
                    ></input>
                    <i
                        className="fas fa-times dateInputReseter"
                        onClick={() => {
                            filters_set((currentFilters) => {
                                return { ...currentFilters, minDate: null }
                            })
                        }}
                    ></i>
                </div>
            </div>
            <div className="dateSelectionRow">
                <label htmlFor="maxDateInput">{lang.pages.reportsMap.before}</label>
                <div>
                    <input
                        type="date"
                        className="DYSTInput"
                        id="maxDateInput"
                        value={filters.maxDate ? formatDate(filters.maxDate) : undefined}
                        onChange={(e) => {
                            const saveEvent = e.target
                            filters_set((oldFilters) => {
                                return {
                                    ...oldFilters,
                                    maxDate: saveEvent.valueAsDate || undefined,
                                }
                            })
                        }}
                    ></input>

                    <i
                        className="fas fa-times"
                        onClick={() => {
                            filters_set((currentFilters) => {
                                return { ...currentFilters, maxDate: undefined }
                            })
                        }}
                    ></i>
                </div>
            </div>
            <h2>{lang.pages.reportsMap.filterByName}</h2>
            <input
                value={filters.name || ''}
                className="DYSTInput"
                onChange={(e) => {
                    const newValue = e.target.value && e.target.value === '' ? undefined : e.target.value
                    filters_set((oldFilters) => {
                        return {
                            ...oldFilters,
                            name: newValue,
                        }
                    })
                }}
            ></input>
            <h2>{lang.pages.reportsMap.filterByEmail}</h2>
            <input
                value={filters.email || ''}
                className="DYSTInput"
                onChange={(e) => {
                    const newValue = e.target.value && e.target.value === '' ? undefined : e.target.value
                    filters_set((oldFilters) => {
                        return {
                            ...oldFilters,
                            email: newValue,
                        }
                    })
                }}
            ></input>
        </div>
    )
}

export default FilterSelection

function formatDate(date: Date) {
    let month = '' + (date.getMonth() + 1)
    let day = '' + date.getDate()
    const year = date.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
}
